import axios from 'axios';

export default {
  fetchCommissions(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/commissions", {params})
      .then(results=>{
        return results.data;
      })
  },
  selectCommission (id, selectedMonthYear) {
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/commissions/"+id+"/select", { selectedMonthYear })
      .then(results=>{
        return results.data;
      })
  },
  selectCommissions (ids, selectedMonthYear) {
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/commissions/select", { id: ids, selectedMonthYear })
      .then(results=>{
        return results.data;
      })
  },
  downloadReport(filename, params){
    const url = `${process.env.VUE_APP_PORTAUS_API_URL}:${process.env.VUE_APP_PORTAUS_API_PORT}/API/latest/admin/commissions/report`;

    return axios({
          url: url,
          method: 'GET',
          params,
          responseType: 'blob', // important
        }).then((response) => {
           const url = window.URL.createObjectURL(new Blob([response.data]));
           const link = document.createElement('a');
           link.href = url;
           link.setAttribute('download', filename); //or any other extension
           document.body.appendChild(link);
           link.click();
        });
  }
}
